import { Capacitor } from '@capacitor/core';

/**
 * 平台判断。
 *
 * src/native/ 下的每个模块都遵循同一个模式：原生走 Capacitor 插件，
 * 浏览器走 Web API 降级实现。这样开发时不用每次都装 APK 才能调，
 * 管理端在浏览器里也能用同一份代码。
 *
 * 降级实现不是摆设 —— 管理端的补录打卡、后台看照片都真的跑在浏览器里。
 */
export const isNative = Capacitor.isNativePlatform();

export const platformName = Capacitor.getPlatform(); // 'android' | 'ios' | 'web'

/** 某个原生插件是否可用。插件没装或在浏览器里都会返回 false。 */
export function hasPlugin(name: string): boolean {
  return Capacitor.isPluginAvailable(name);
}
